import { makeStyles } from '@fluentui/react-theme-provider';

export const useRoleLibraryPageStyles = makeStyles({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '40px',
    zIndex: 1,
    margin: '40px',
    flexWrap: 'nowrap',
    '@media (max-width: 320px)': {
      margin: '16px',
    },
  },

  roleDescriptionContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    '@media (max-width: 640px)': {
      display: 'block',
    },
  },

  profileContent: {
    display: 'flex',
    gap: '40px',
    flexWrap: 'nowrap',
    minWidth: 0,
    '@media (max-width: 320px)': {
      flexWrap: 'wrap',
      gap: '16px',
    },
  },

  subHeaderContent: {
    marginTop: '8px',
  },

  mainContent: {
    flexGrow: '1',
    minWidth: 0,
  },
  linkContainer: {
    marginTop: '8px',
  },
  link: {
    color: '#b836aa !important',
    textDecorationLine: 'underline',
  },
});
